// extracted by mini-css-extract-plugin
export default {"header":"Nav_header__N9nSZ","wrapper":"Nav_wrapper__hHWKA","im_icon":"Nav_im_icon__KYRio","navigation":"Nav_navigation__kv2MV","heading_text":"Nav_heading_text__pJzll"};